export default __webpack_public_path__ + "static/media/office365-long.5e5efc57.svg";